module.exports = __webpack_public_path__ + "img/N4 200X200.a4a43f10.png";